import { render, staticRenderFns } from "./InmueblesDetail.vue?vue&type=template&id=1e0e48d2&"
import script from "./InmueblesDetail.vue?vue&type=script&lang=js&"
export * from "./InmueblesDetail.vue?vue&type=script&lang=js&"
import style0 from "./InmueblesDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports